import "./App.scss";
import React from "react";
import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import { Home } from "./pages/Home";
import { AboutUs } from "./pages/AboutUs";
import { PackageArchive } from "./pages/PackageArchive";
import { PackageDetail } from "./pages/PackageDetail";
import { Layout } from "./pages/Layout";
import { DataPage1 } from "./pages/DataPage1";
import Admin from "./pages/Admin";
function App() {
    return (
        <div className="main">
            <BrowserRouter>
                <Routes>
                    <Route path="/SecretPage" element={<Admin />} />
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Home />} />
                        <Route path="about" element={<AboutUs />} />
                        <Route path="archive" element={<PackageArchive />} />
                        <Route path="detail" element={<PackageDetail />} />
                        <Route path="data1" element={<DataPage1 />} />
                    <Route path="*" element={<Home/>}></Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;

